import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-check': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM345.3 287.9L317.1 259.5C312.5 254.8 304.9 254.8 300.2 259.5L194.1 364.7 148.1 318.3C143.5 313.6 135.9 313.6 131.2 318.2L102.8 346.4C98.1 351.1 98 358.7 102.7 363.4L185.3 446.7C190 451.4 197.6 451.4 202.3 446.7L345.2 304.9C349.9 300.3 350 292.7 345.3 287.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-check.js
// module id = zMD8
// module chunks = 144